import * as React from "react";
import ReactDOM from 'react-dom';
import './index.css';
import defaultState from "./defaultState";



import VariablesForm from "./VariablesForm";
import CompoundInterestChart from "./CompoundInterestChart";



function App() {
  const [state, setState] = React.useState(defaultState);

  return (
    <div id="annualCompoundCalculator">
      <VariablesForm onUpdate={variables => setState(variables)} />
      <hr />
      <CompoundInterestChart {...state} />
    </div>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);